<span *ngIf="value > 0"
  [title]="value"
  [ngClass]="{ 'top-0 end-0': !small, 'ms-1 badge-small': small }"
  class="position-absolute badge rounded-pill bg-primary">
  {{ value > 9 ? '9+' : (value | number) }}
</span>
